import React, { useState, useEffect } from 'react';

const EditModal = ({ faq, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    question: '',
    answer: '',
    category: 'general'
  });

  useEffect(() => {
    if (faq) {
      setFormData({
        question: faq.question,
        answer: faq.answer,
        category: faq.category
      });
    }
  }, [faq]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onSave(faq.id, formData);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal" onClick={handleBackdropClick}>
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <h2>✏️ Редактировать FAQ</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="editQuestion">Вопрос:</label>
            <textarea
              id="editQuestion"
              name="question"
              value={formData.question}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="editAnswer">Ответ:</label>
            <textarea
              id="editAnswer"
              name="answer"
              value={formData.answer}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="editCategory">Категория:</label>
            <select
              id="editCategory"
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="general">Общие</option>
              <option value="integration">Интеграция</option>
              <option value="search">Поиск</option>
              <option value="technical">Технические</option>
              <option value="support">Поддержка</option>
            </select>
          </div>
          <button type="submit" className="btn">Сохранить изменения</button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>Отмена</button>
        </form>
      </div>
    </div>
  );
};

export default EditModal; 